import {
  colors,
  fontSizing,
  fontWeights,
  icons,
  getTestAttributes,
  slug,
  noop,
  sizing,
} from '@chillibean/component-library';
import { Icon } from '@iconify/react';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function Tag(props) {
  const { children, ...otherProps } = props;

  return <StyledTag {...otherProps}>{children}</StyledTag>;
}

Tag.propTypes = {
  children: PropTypes.node.isRequired,
};

function Column(props) {
  const { disabled = false, label, loading = false, onClick = noop } = props;

  const numberOfCharacters = label.length;

  const handleOnClick = () => {
    if (disabled) return;

    onClick();
  };

  return (
    <Tag
      className={clsx({
        column: true,
        disabled: disabled,
      })}
      id="column-tag"
      numberOfCharacters={numberOfCharacters}
      onClick={handleOnClick}
      {...getTestAttributes(slug(`${label}-name-label`))}
    >
      <StyledLabel
        className={clsx({
          'disabled': disabled,
          'loading': loading,
          'tag-label': true,
        })}
        id="tag-column-label"
      >
        {label}
      </StyledLabel>
      {!disabled && (
        <StyledEdit className="tag-edit" id="tag-column-edit">
          <Icon icon={icons.baselineEdit} />
        </StyledEdit>
      )}
    </Tag>
  );
}

Column.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

function Row(props) {
  const { disabled = false, label, loading = false, onClick = noop } = props;

  const numberOfCharacters = label.length;

  const handleOnClick = () => {
    if (disabled) return;

    onClick();
  };

  return (
    <Tag
      className={clsx({
        disabled: disabled,
        row: true,
      })}
      id="row-tag"
      numberOfCharacters={numberOfCharacters}
      onClick={handleOnClick}
      {...getTestAttributes(slug(`${label}-name-label`))}
    >
      <StyledLabel
        className={clsx({
          'disabled': disabled,
          'loading': loading,
          'tag-label': true,
        })}
        id="tag-row-label"
      >
        {label}
      </StyledLabel>
      {!disabled && (
        <StyledEdit className="tag-edit" id="tag-row-edit">
          <Icon icon={icons.baselineEdit} />
        </StyledEdit>
      )}
    </Tag>
  );
}

Row.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

const StyledLabel = styled.span`
  &.loading {
    visibility: hidden;
  }
`;

const StyledEdit = styled.span``;

const StyledTag = styled.span`
  background-color: ${colors.grey.tertiary};
  border-radius: ${sizing.small} ${sizing.small} 0 0;
  padding-left: ${sizing.small};
  padding-right: ${sizing.small};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSizing.small};
  font-weight: ${fontWeights.normal};
  color: ${colors.grey.primary};
  cursor: pointer;
  white-space: nowrap;
  position: absolute;

  height: 20px;
  width: calc(20px + ${(props) => props.numberOfCharacters}ch);

  &.column {
    top: -20px;
    right: calc(calc(calc(${(props) => props.numberOfCharacters}ch + 20px) * -1) - 20px);
  }

  &.row {
    transform: rotate(-90deg);
    transform-origin: bottom left;
    bottom: calc(calc(calc(${(props) => props.numberOfCharacters}ch + 20px) * -1) - 20px);
    left: 15px;
  }

  &.disabled {
    background-color: ${colors.grey.secondary};
  }

  > span.tag-label {
    display: flex;
    opacity: 1;

    &.disabled {
      color: ${colors.grey.primaryAlpha('20')};
    }
  }

  > span.tag-edit {
    display: none;
    opacity: 0;
  }

  &:hover {
    > span.tag-label {
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;

      &.disabled {
        display: flex;
        opacity: 1;
      }
    }

    > span.tag-edit {
      display: flex;
      opacity: 1;
      transition: opacity 0.3s ease-in-out;
    }
  }
`;

Tag.Column = Column;
Tag.Row = Row;

export { Tag };
export default Tag;
